import { useTranslation } from 'react-i18next'
import { TRA_TOKEN_URL } from 'src/utils/constants'

/** Hint under the TRA API key field pointing hosts to MINCIT's token page. */
export const TraTokenLink = () => {
  const { t } = useTranslation()
  return (
    <p className="mt-1 text-xs text-text-placeholder">
      {t('reporting.onboarding.traApiKeyHint')}{' '}
      <a
        href={TRA_TOKEN_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary underline hover:no-underline"
        data-testid="tra-token-link"
      >
        {t('reporting.traTokenLink')}
      </a>
    </p>
  )
}
